import React from "react";
import "./Field.css";

interface FieldProps {
  label: string;
  value: string | null | undefined;
  link?: boolean;
}

export default function Field({ label, value, link }: FieldProps) {
  return (
    <div className="field">
      <span className="field__label">{label}</span>
      {value ? (
        link ? (
          <a href={value} target="_blank" rel="noreferrer" className="field__link">
            {value}
          </a>
        ) : (
          <span className="field__value">{value}</span>
        )
      ) : (
        <span className="field__empty">—</span>
      )}
    </div>
  );
}